<template>
  <section>
    <!--工具条-->
    <!-- <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar> -->
    <div style="display: none">
      <div id="report_holder"></div>
    </div>
    <el-form :inline="true">
      <el-form-item label="编号">
        <el-input
          v-model="filters.code"
          placeholder="编号"
          @change="getWeighingInHistry(1)"
        ></el-input>
      </el-form-item>
      <el-form-item label="车号">
        <el-input
          v-model="filters.license"
          placeholder="车号"
          @change="getWeighingInHistry(1)"
        ></el-input>
      </el-form-item>
      <el-form-item label="物资名">
        <el-input
          v-model="filters.matname"
          placeholder="物资名"
          @change="getWeighingInHistry(1)"
        ></el-input>
      </el-form-item>
      <el-form-item label="仓库名">
        <el-input
          v-model="filters.whname"
          placeholder="仓库名"
          @change="getWeighingInHistry(1)"
        ></el-input>
      </el-form-item>
      <el-form-item label="起止时间">
        <el-date-picker
          type="datetime"
          placeholder="开始日期"
          v-model="filters.startTime"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
        <el-date-picker
          type="datetime"
          placeholder="结束日期"
          v-model="filters.endTime"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="单据类型">
        <el-select
          v-model="filters.weightType"
          placeholder="请选择状态"
          @change="getWeighingInHistry(1)"
        >
          <el-option label="所有" :value="-1"></el-option>
          <el-option label="补单" :value="100"></el-option>
          <el-option label="磅单" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="单据状态">
        <el-select
          v-model="filters.status"
          placeholder="请选择状态"
          @change="getWeighingInHistry(1)"
        >
          <el-option label="所有" :value="-1"></el-option>
          <el-option label="已过毛" :value="0"></el-option>
          <el-option label="已过皮" :value="100"></el-option>
          <el-option label="完成" :value="200"></el-option>
          <el-option label="已入库" :value="400"></el-option>
          <el-option label="已审核" :value="500"></el-option>
          <el-option label="已结算" :value="900"></el-option>
          <el-option label="已作废" :value="-100"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="磅秤">
        <el-select
          v-model="filters.weightID"
          placeholder="选择磅秤"
          :clearable="true"
          @change="getWeighingInHistry(1)"
        >
          <el-option
            v-for="item in whsettingListSelect"
            :key="item.Id + '_bc'"
            :label="item.Name"
            v-model="item.Id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getWeighingInHistry(1)">
          查询
        </el-button>
        <el-button type="primary" v-if="canAdd" @click="handleAdd">
          新增
        </el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table
      :data="WeighingInList"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      @selection-change="selsChange"
      style="width: 100%; margin-top: 20px"
      border
      show-summary
      :summary-method="getSummaries"
    >
      <el-table-column label="过磅信息" width="250">
        <template slot-scope="scope" style="max-height: 100%">
          <div>
            <el-link type="primary" @click="handleDetail(scope.row)">
              {{ scope.row.Code }}
            </el-link>
          </div>

          <div>
            <el-tag :type="scope.row.WeightType == 100 ? 'success' : 'warning'">
              {{ scope.row.WeightType == 100 ? "补" : "磅" }}
            </el-tag>
            <el-tag
              :type="
                scope.row.Status == 0
                  ? 'success'
                  : scope.row.Status == 100
                  ? 'success'
                  : scope.row.Status == 200
                  ? 'success'
                  : scope.row.Status == 300
                  ? 'danger'
                  : scope.row.Status == 400
                  ? 'danger'
                  : scope.row.Status == 500
                  ? 'info'
                  : scope.row.Status == 900
                  ? 'warning'
                  : ''
              "
              disable-transitions
            >
              {{
                scope.row.Status == 0
                  ? "已过毛"
                  : scope.row.Status == 100
                  ? "已过皮"
                  : scope.row.Status == 200
                  ? "已打印"
                  : scope.row.Status == 300
                  ? "完成"
                  : scope.row.Status == 400
                  ? "已入库"
                  : scope.row.Status == 500
                  ? "已审核"
                  : scope.row.Status == 900
                  ? "已结算"
                  : "已作废"
              }}
            </el-tag>
            车号:{{ scope.row.License }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="物资信息">
        <template slot-scope="scope" style="max-height: 100%">
          <div>物资:{{ scope.row.MatName }}</div>
          <div>仓库:{{ scope.row.WarehouseName }}</div>
        </template>
      </el-table-column>
      <el-table-column label="毛重/皮重">
        <template slot-scope="scope" style="max-height: 100%">
          <div>
            毛重:{{ scope.row.GrossWeight }} 皮重:{{ scope.row.TareWeight }}
          </div>
          <div>
            扣重:{{ scope.row.BuckleWeight }} 净重:{{ scope.row.NetWeight }}
          </div>
        </template>
      </el-table-column>

      <el-table-column label="方量/价格">
        <template slot-scope="scope" style="max-height: 100%">
          <div>
            方量:{{ scope.row.DiscountQuantity }} 净重:{{
              scope.row.OtherNetWeight
            }}
          </div>
          <div>
            单价:{{ scope.row.Price }} 运费:{{ scope.row.TransportPrice }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="供应商/运输单位">
        <template slot-scope="scope" style="max-height: 100%">
          <div>供应商:{{ scope.row.SupplierName }}</div>
          <div>运输单位:{{ scope.row.TransportName }}</div>
        </template>
      </el-table-column>
      <el-table-column label="状态信息">
        <template slot-scope="scope" style="max-height: 100%">
          <div>过磅员:{{ scope.row.CreateUser }}</div>
          <div>备注:{{ scope.row.Remark }}</div>
        </template>
      </el-table-column>
      <el-table-column label="过磅时间">
        <template slot-scope="scope" style="max-height: 100%">
          <div>过毛:{{ scope.row.GrossTime }}</div>
          <div>过皮:{{ scope.row.TareTime }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-link
            v-if="scope.row.Status <= 300 && scope.row.Status >= 0 && canEdit"
            type="primary"
            @click="
              () => {
                currentRow = scope.row;
                handleEdit();
              }
            "
          >
            编辑
          </el-link>
          <el-link
            v-if="scope.row.Status < 200 && scope.row.Status >= 0 && canDelete"
            type="danger"
            @click="
              () => {
                sels.push(scope.row);
                handleDel();
              }
            "
          >
            删除
          </el-link>
          <el-link
            v-if="scope.row.Status <= 300 && scope.row.Status >= 0"
            type="primary"
            @click="
              () => {
                currentRow = scope.row;
                handlePrint();
              }
            "
          >
            打印[{{ scope.row.PrintCount }}]
          </el-link>
          <el-link
            v-if="scope.row.Status < 400 && scope.row.Status >= 0"
            type="primary"
            @click="
              () => {
                currentRow = scope.row;
                handleAbandon();
              }
            "
          >
            作废
          </el-link>
          <el-link
            v-if="scope.row.Status == 400"
            type="primary"
            @click="
              () => {
                currentRow = scope.row;
                handleVerify();
              }
            "
          >
            审核
          </el-link>
          <el-link
            v-if="scope.row.Status == 500"
            type="primary"
            @click="
              () => {
                currentRow = scope.row;
                handleOutVerify();
              }
            "
          >
            取消审核
          </el-link>
          <el-link
            v-if="scope.row.Status > 100 && scope.row.Status < 400"
            type="primary"
            @click="
              () => {
                currentRow = scope.row;
                handleInMat();
              }
            "
          >
            入库
          </el-link>
          <el-link
            v-if="scope.row.Status == 400"
            type="primary"
            @click="
              () => {
                currentRow = scope.row;
                handleOutReciveWh();
              }
            "
          >
            取消入库
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      layout="total, sizes, prev, pager, next, jumper"
      :page-size="pageSize"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      class="my-pagination"
    ></el-pagination>
    <!--编辑界面-->
    <el-dialog
      :title="isEdit ? '编辑' + editForm.Code : '新增'"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
      width="50%"
    >
      <el-form
        :model="editForm"
        label-width="100px"
        :rules="editFormRules"
        ref="editForm"
        class="editForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="磅秤">
              <el-select
                v-model="editForm.WeightID"
                placeholder="选择磅秤"
                :clearable="true"
              >
                <el-option
                  v-for="item in whsettingListSelect"
                  :key="item.Id + '_bc1'"
                  :label="item.Name"
                  v-model="item.Id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车牌号">
              <el-input v-model="editForm.License"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="毛重">
              <el-input
                v-model="editForm.GrossWeight"
                @input="NetWeightCount"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="毛重时间">
              <el-date-picker
                type="datetime"
                placeholder="过毛时间"
                v-model="editForm.GrossTime"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="皮重">
              <el-input
                v-model="editForm.TareWeight"
                @input="NetWeightCount"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="皮重时间">
              <el-date-picker
                type="datetime"
                placeholder="过皮时间"
                v-model="editForm.TareTime"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="物资">
              <template>
                <el-select
                  v-model="editForm.MatID"
                  filterable
                  placeholder="请选择"
                  @change="selectMaterial"
                >
                  <el-option
                    v-for="item in materialList"
                    :key="item.Id + '_addmat'"
                    :label="
                      item.Name + (item.MatGrade == null ? '' : item.MatGrade)
                    "
                    v-model="item.Id"
                  ></el-option>
                </el-select>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="仓库">
              <template>
                <el-select
                  v-model="editForm.WarehouseID"
                  filterable
                  placeholder="请选择"
                  @change="selectWarehouse"
                >
                  <el-option
                    v-for="item in warehouseList"
                    :key="item.Id + '_addwh'"
                    :label="item.Name"
                    v-model="item.Id"
                  ></el-option>
                </el-select>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="扣重">
              <el-input
                v-model="editForm.BuckleWeight"
                @input="NetWeightCount"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="供应商">
              <template>
                <el-select
                  v-model="editForm.SupplierName"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择"
                  @change="selectSupplier"
                  :clearable="true"
                >
                  <el-option
                    v-for="item in supplierList"
                    :key="item.Id + '_addgys'"
                    :label="item.Name"
                    v-model="item.Name"
                  ></el-option>
                </el-select>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="扣除率">
              <el-input
                v-model="editForm.DeductionRate"
                @input="NetWeightCount"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="运输单位">
              <template>
                <el-select
                  v-model="editForm.TransportName"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择"
                  @change="selectTransport"
                  :clearable="true"
                >
                  <el-option
                    v-for="item in transportList"
                    :key="item.Id + '_addys'"
                    :label="item.Name"
                    v-model="item.Name"
                  ></el-option>
                </el-select>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="净重">
              <el-input v-model="editForm.NetWeight" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产地">
              <template>
                <el-select
                  v-model="editForm.PlaceOfOriginName"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择"
                  @change="selectPlaceOfOrigin"
                  :clearable="true"
                >
                  <el-option
                    v-for="item in placeOfOriginList"
                    :key="item.Id + '_addcd'"
                    :label="item.Name"
                    v-model="item.Name"
                  ></el-option>
                </el-select>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="折方">
              <el-input v-model="editForm.DiscountQuantity"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="对方折方">
              <el-input v-model="editForm.OtherDiscountQuantity"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="对方毛重">
              <el-input
                v-model="editForm.OtherGrossWeight"
                @input="NetWeightCount"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="对方皮重">
              <el-input
                v-model="editForm.OtherTareWeight"
                @input="NetWeightCount"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="对方净重">
              <el-input v-model="editForm.OtherNetWeight"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="净重差异">
              <el-input v-model="editForm.NetWeightDifference"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input v-model="editForm.Remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col
            :v-if="shotGList.length > 0 ? true : false"
            :span="12"
            v-for="(item, i) in shotGList"
            :key="i + 'shotG'"
          >
            <img
              :id="'shotG_' + i"
              :src="item.FilePath"
              style="width: 270px; height: 180px; border: 1px solid"
            />
          </el-col>
        </el-row>
        <el-row>
          <el-col
            :v-if="shotTList.length > 0 ? true : false"
            :span="12"
            v-for="(item, i) in shotTList"
            :key="i + 'shotT'"
          >
            <img
              :id="'shotT_' + i"
              :src="item.FilePath"
              style="width: 270px; height: 180px; border: 1px solid"
            />
          </el-col>
        </el-row>
        <!-- 从这里结束 -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
        >
          提交
        </el-button>
      </div>
    </el-dialog>

    <!-- 详情 -->
    <el-dialog
      title="详情"
      :visible.sync="isShowDetail"
      v-model="isShowDetail"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form :model="DetailDm" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="过磅单号">
              {{ DetailDm.Code }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车牌号">
              {{ DetailDm.License }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="毛重">
              {{ DetailDm.GrossWeight }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="物资">
              {{ DetailDm.MatName }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="皮重">
              {{ DetailDm.TareWeight }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="仓库">
              {{ DetailDm.WarehouseName }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="扣重">
              {{ DetailDm.BuckleWeight }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="供应商">
              {{ DetailDm.SupplierName }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="扣除率">
              {{ DetailDm.DeductionRate }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="运输单位">
              {{ DetailDm.TransportName }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="净重">
              {{ DetailDm.NetWeight }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产地">
              {{ DetailDm.PlaceOfOriginName }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="折方">
              {{ DetailDm.DiscountQuantity }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="对方折方">
              {{ DetailDm.OtherDiscountQuantity }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="对方毛重">
              {{ DetailDm.OtherGrossWeight }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="对方皮重">
              {{ DetailDm.OtherTareWeight }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="对方净重">
              {{ DetailDm.OtherNetWeight }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="净重差异">
              {{ DetailDm.NetWeightDifference }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col
            :v-if="shotGList.length > 0 ? true : false"
            :span="12"
            v-for="(item, i) in shotGList"
            :key="i + 'shotG'"
          >
            <img
              :id="'shotG_' + i"
              :src="item.FilePath"
              style="width: 270px; height: 180px; border: 1px solid"
            />
          </el-col>
        </el-row>
        <el-row>
          <el-col
            :v-if="shotTList.length > 0 ? true : false"
            :span="12"
            v-for="(item, i) in shotTList"
            :key="i + 'shotT'"
          >
            <img
              :id="'shotT_' + i"
              :src="item.FilePath"
              style="width: 270px; height: 180px; border: 1px solid"
            />
          </el-col>
        </el-row>
        <!-- 从这里结束 -->
      </el-form>
    </el-dialog>
  </section>
</template>

<script>
//引入warehouse.js的所有export的对象,并起别名为api,通过api.***访问成员
import { BaseApiUrl } from "../../api/api";
import * as api from "../../api/weighingIn";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import printJS from "print-js";
import { runReport } from "../../api/viewReport";
export default {
  components: { Toolbar },
  data() {
    return {
      buttonList: [],
      currentRow: null,
      filters: {
        name: "",
        startTime: "",
        endTime: "",
        weightType: -1,
        code: "",
      },
      WeighingInList: [],
      WeighingInListSum: {},
      total: 0,
      page: 1,
      pageSize: 20,
      listLoading: false,
      sels: [], //列表选中列
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        // Name: [{ required: true, message: "请输入仓库名称", trigger: "blur" }],
      },
      //编辑界面数据
      editForm: {},
      materialList: [], //物资列表
      warehouseList: [], //仓库列表
      supplierList: [], //供应商列表
      transportList: [], //运输单位列表
      placeOfOriginList: [], //产地列表
      whsettingListSelect: [], //磅秤列表
      whsetting: {}, //当前选择磅秤
      isEdit: false,
      isShowDetail: false,
      DetailDm: {},
      shotGList: [], //过毛拍照List
      shotTList: [], //过皮拍照List
    };
  },
  computed: {
    //计算属性,判断是否有权编辑
    canAdd() {
      let index = this.buttonList.findIndex(
        (s) => s.name === "新增" || s.name === "添加"
      );
      return index > -1;
    },
    //计算属性,判断是否有权编辑
    canEdit() {
      let index = this.buttonList.findIndex(
        (s) => s.name === "编辑" || s.name === "修改"
      );
      return index > -1;
    },
    //计算属性,判断是否有权删除
    canDelete() {
      let index = this.buttonList.findIndex((s) => s.name === "删除");
      return index > -1;
    },
    //计算属性,判断是否有权删除
    canShowPrice() {
      let index = this.buttonList.findIndex((s) => s.name === "查看单价");
      return index > -1;
    },
  },
  methods: {
    getSummaries(param) {
      // sums[1]="毛重："+this.WeighingInListSum.GrossWeight;
      // sums[2]="皮重："+this.WeighingInListSum.TareWeight;
      // sums[3]="扣重："+this.WeighingInListSum.BuckleWeight;
      // sums[4]="净重："+this.WeighingInListSum.NetWeight;
      // sums[5]="折方："+this.WeighingInListSum.DiscountQuantity;
      // sums[6]="对方："+this.WeighingInListSum.OtherNetWeight;
      var sums = [];
      sums[0] = "合计";
      sums[1] = "毛重：" + this.WeighingInListSum.GrossWeight;
      sums[2] = "皮重：" + this.WeighingInListSum.TareWeight;
      sums[3] = "扣重：" + this.WeighingInListSum.BuckleWeight;
      sums[4] =
        "净重：" + this.WeighingInListSum &&
        this.WeighingInListSum.NetWeight > 0
          ? Number(this.WeighingInListSum.NetWeight).toFixed(2)
          : 0;
      sums[5] = "折方：" + this.WeighingInListSum.DiscountQuantity;
      sums[6] = "对方：" + this.WeighingInListSum.OtherNetWeight;
      sums[7] = "";
      sums[8] = "";
      sums[9] = "";
      sums[10] = "";
      return sums;
    },
    //单击表格行事件绑定方法
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    // //工具条绑定事件方法
    // callFunction(item) {
    //   this.filters = {
    //     name: item.search,
    //   };
    //   this[item.Func].apply(this, item);
    // },
    //翻页事件绑定方法
    handleCurrentChange(val) {
      this.page = val;
      this.getWeighingInHistry();
    },
    //获取列表
    getWeighingInHistry(optype) {
      if (optype == 1) {
        this.page = 1;
      }
      let para = {
        page: this.page,
        license: this.filters.license,
        code: this.filters.code,
        matname: this.filters.matname,
        whname: this.filters.whname,
        status: this.filters.status,
        endTime: this.filters.endTime,
        startTime: this.filters.startTime,
        weightID: this.filters.weightID,
        weightType: this.filters.weightType,
        intPageSize: this.pageSize,
        isHistry: 1,
      };
      this.listLoading = true;
      api.getWeighingInHistryListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.WeighingInList = res.data.response.data;
        this.WeighingInListSum = res.data.responsesum;
        this.listLoading = false;

        this.currentRow = null;
        this.sels = [];
      });
    },
    //获取磅秤列表
    getWhsettingDetail() {
      let para = {
        key: 0,
      };
      this.listLoading = true;
      api.getWhsettingDetail(para).then((res) => {
        if (res.data.response && res.data.response.length > 0) {
          this.whsettingListSelect = res.data.response;
        }
      });
    },
    //执行删除
    handleDel() {
      if (!this.sels || this.sels.length <= 0) {
        this.$message({
          message: "请勾选要删除的数据",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除选中的记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;

          let para = this.sels.map((item) => item.Id);

          api.batchDeleteWeighingIn(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getWeighingInHistry();
          });
        })
        .catch(() => {})
        .finally(() => {
          this.listLoading = false;
        });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.isEdit = true;
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
      this.shotTList = [];
      this.shotGList = [];
      if (!!this.currentRow.GrossImgPath) {
        var UploadUrls = this.currentRow.GrossImgPath;
        let souceImgFile = JSON.parse(UploadUrls);
        souceImgFile.map((e) => {
          e.FilePath = BaseApiUrl + "/" + e.FilePath;
        });
        this.shotGList = souceImgFile;
      }
      if (!!this.currentRow.TareImgPath) {
        var UploadUrls = this.currentRow.TareImgPath;
        let souceImgFile = JSON.parse(UploadUrls);
        souceImgFile.map((e) => {
          e.FilePath = BaseApiUrl + "/" + e.FilePath;
        });
        this.shotTList = souceImgFile;
      }
    },
    //显示新增界面
    handleAdd() {
      this.isEdit = false;
      this.editFormVisible = true;
      this.shotTList = [];
      this.shotGList = [];
      this.editForm = { WeightType: 100 };
    },
    //执行编辑
    editSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editLoading = true;

          let para = Object.assign({}, this.editForm);
          let user = JSON.parse(window.localStorage.user);
          if (user && user.uID > 0) {
          } else {
            this.$message({
              message: "用户信息为空，先登录",
              type: "error",
            });
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          }
          if (this.isEdit) {
            api
              .editWeighingIn(para)
              .then((res) => {
                if (res && res.data && res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["editForm"].resetFields();
                  this.editFormVisible = false;
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
                this.getWeighingInHistry();
                this.GetWeighingInBaseData();
              })
              .finally(() => {
                this.editLoading = false;
              });
          } else {
            api
              .addWeighingIn(para)
              .then((res) => {
                if (res && res.data && res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["editForm"].resetFields();
                  this.editFormVisible = false;
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
                this.getWeighingInHistry();
                this.GetWeighingInBaseData();
              })
              .finally(() => {
                this.editLoading = false;
              });
          }
        }
      });
    },
    //获取进料过磅基础信息
    GetWeighingInBaseData() {
      api.getWeighingInBaseData().then((res) => {
        this.materialList = res.data.response.MaterialList;
        this.warehouseList = res.data.response.WarehouseList;
        this.supplierList = res.data.response.SupplierList;
        this.transportList = res.data.response.TransportList;
        this.placeOfOriginList = res.data.response.PlaceOfOriginList;
      });
    },
    selectMaterial(id) {
      var itemMat = this.materialList.filter((e) => e.Id == id)[0];
      this.editForm.MatName = itemMat.Name;
      this.editForm.MatGrade = itemMat.MatGrade;
      this.editForm.MatID = id;
      this.editForm.CubRate = itemMat.CubRate;
      this.NetWeightCount();
    },
    selectWarehouse(id) {
      var itemWarehouse = this.warehouseList.filter((e) => e.Id == id)[0];
      this.editForm.WarehouseName = itemWarehouse.Name;
      this.editForm.WarehouseID = id;
    },
    selectSupplier(name) {
      var itemSupplier = this.supplierList.filter((e) => e.Name == name);
      if (itemSupplier && itemSupplier.length > 0) {
        this.editForm.SupplierID = itemSupplier[0].Id;
      } else {
        this.editForm.SupplierID = 0;
      }
      this.editForm.SupplierName = name;
    },
    selectTransport(name) {
      var itemTransport = this.transportList.filter((e) => e.Name == name);
      if (itemTransport && itemTransport.length > 0) {
        this.editForm.TransportID = itemTransport[0].Id;
      } else {
        this.editForm.TransportID = 0;
      }
      this.editForm.TransportName = name;
    },
    selectPlaceOfOrigin(name) {
      var itemPlaceOfOrigin = this.placeOfOriginList.filter(
        (e) => e.Name == name
      );
      if (itemPlaceOfOrigin && itemPlaceOfOrigin.length > 0) {
        this.editForm.PlaceOfOriginID = itemPlaceOfOrigin[0].Id;
      } else {
        this.editForm.PlaceOfOriginID = 0;
      }
      this.editForm.PlaceOfOriginName = name;
    },
    // 显示窗口
    handleDetail(row) {
      this.DetailDm = row;
      this.isShowDetail = !this.isShowDetail;
      this.shotTList = [];
      this.shotGList = [];
      if (row.GrossImgPath.length > 0) {
        var UploadUrls = row.GrossImgPath;
        let souceImgFile = JSON.parse(UploadUrls);
        souceImgFile.map((e) => {
          e.FilePath = BaseApiUrl + "/" + e.FilePath;
        });
        this.shotGList = souceImgFile;
      }
      if (row.TareImgPath.length > 0) {
        var UploadUrls = row.TareImgPath;
        let souceImgFile = JSON.parse(UploadUrls);
        souceImgFile.map((e) => {
          e.FilePath = BaseApiUrl + "/" + e.FilePath;
        });
        this.shotTList = souceImgFile;
      }
    },
    //勾选表格数据事件绑定方法
    selsChange(sels) {
      this.sels = sels;
    },
    //切换分页大小绑定方法
    handleSizeChange(size) {
      this.pageSize = size;
      this.getWeighingInHistry(1);
    },
    //打印
    handlePrint() {
      this.editLoading = true;
      let para = Object.assign({}, this.currentRow);
      let user = JSON.parse(window.localStorage.user);
      if (user && user.uID > 0) {
      } else {
        this.$message({
          message: "登录信息已过期,请重新登录",
          type: "error",
        });
        this.$router.replace(
          this.$route.query.redirect ? this.$route.query.redirect : "/"
        );
      }
      this.print();
    },
    print() {
      let row = this.currentRow;
      let para = {
        id: row.Id,
        printId: null,
      };
      api
        .getPrintContent(para)
        .then((res) => {
          if (res.data.success) {
            runReport(
              res.data.response.PrintEntity,
              res.data.response.PrintModel
            );
            let syles = "";
            if (document.styleSheets.length > 1) {
              for (let i = document.styleSheets.length - 1; i >= 0; i--) {
                if (
                  document.styleSheets[i].ownerNode.id.indexOf("gridcss") > 0
                ) {
                  let rulesList = document.styleSheets[i].cssRules;
                  for (let j = 0; j < rulesList.length; j++) {
                    syles += rulesList[j].cssText;
                  }
                  break;
                }
              }
            }
            printJS({
              printable: "report_holder",
              type: "html",
              header: null,
              targetStyles: ["*"],
              style: syles,
              scanStyles: false,
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
          this.getWeighingInHistry();
        })
        .finally(() => {
          this.editLoading = false;
        });
    },
    //作废
    handleAbandon() {
      this.editLoading = true;
      let para = Object.assign({}, this.currentRow);
      let user = JSON.parse(window.localStorage.user);
      if (user && user.uID > 0) {
      } else {
        this.$message({
          message: "登录信息已过期,请重新登录",
          type: "error",
        });
        this.$router.replace(
          this.$route.query.redirect ? this.$route.query.redirect : "/"
        );
      }
      api
        .cancelWeighingIn(para)
        .then((res) => {
          if (res && res.data && res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
          this.getWeighingInHistry();
        })
        .finally(() => {
          this.editLoading = false;
        });
    },
    //审核
    handleVerify() {
      this.editLoading = true;
      let para = Object.assign({}, this.currentRow);
      let user = JSON.parse(window.localStorage.user);
      if (user && user.uID > 0) {
      } else {
        this.$message({
          message: "登录信息已过期,请重新登录",
          type: "error",
        });
        this.$router.replace(
          this.$route.query.redirect ? this.$route.query.redirect : "/"
        );
      }
      api
        .verifyWeighingIn(para)
        .then((res) => {
          if (res && res.data && res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
          this.getWeighingInHistry();
        })
        .finally(() => {
          this.editLoading = false;
        });
    },
    //取消审核
    handleOutVerify() {
      this.editLoading = true;
      let para = Object.assign({}, this.currentRow);
      let user = JSON.parse(window.localStorage.user);
      if (user && user.uID > 0) {
      } else {
        this.$message({
          message: "登录信息已过期,请重新登录",
          type: "error",
        });
        this.$router.replace(
          this.$route.query.redirect ? this.$route.query.redirect : "/"
        );
      }
      api
        .outVerifyWeighingIn(para)
        .then((res) => {
          if (res && res.data && res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
          this.getWeighingInHistry();
        })
        .finally(() => {
          this.editLoading = false;
        });
    },
    //入库
    handleInMat() {
      this.editLoading = true;
      let para = Object.assign({}, this.currentRow);
      let user = JSON.parse(window.localStorage.user);
      if (user && user.uID > 0) {
      } else {
        this.$message({
          message: "登录信息已过期,请重新登录",
          type: "error",
        });
        this.$router.replace(
          this.$route.query.redirect ? this.$route.query.redirect : "/"
        );
      }
      api
        .reciveWhWeighingIn(para)
        .then((res) => {
          if (res && res.data && res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
          this.getWeighingInHistry();
        })
        .finally(() => {
          this.editLoading = false;
        });
    },
    //取消入库
    handleOutReciveWh() {
      this.editLoading = true;
      let para = Object.assign({}, this.currentRow);
      let user = JSON.parse(window.localStorage.user);
      if (user && user.uID > 0) {
      } else {
        this.$message({
          message: "登录信息已过期,请重新登录",
          type: "error",
        });
        this.$router.replace(
          this.$route.query.redirect ? this.$route.query.redirect : "/"
        );
      }
      api
        .outReciveWhWeighingIn(para)
        .then((res) => {
          if (res && res.data && res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
          this.getWeighingInHistry();
        })
        .finally(() => {
          this.editLoading = false;
        });
    },
    //计算净重
    NetWeightCount() {
      var grossWeight =
        this.editForm.GrossWeight == "" ||
        this.editForm.GrossWeight == undefined
          ? 0
          : Number(this.editForm.GrossWeight);
      var tareWeight =
        this.editForm.TareWeight == "" || this.editForm.TareWeight == undefined
          ? 0
          : Number(this.editForm.TareWeight);
      var cubRate =
        this.editForm.CubRate == "" || this.editForm.CubRate == undefined
          ? 0
          : Number(this.editForm.CubRate);

      var buckleWeight =
        this.editForm.BuckleWeight == "" ||
        this.editForm.BuckleWeight == undefined
          ? 0
          : Number(this.editForm.BuckleWeight); //扣重1 扣重(kg)
      var deductionRate =
        this.editForm.DeductionRate == "" ||
        this.editForm.DeductionRate == undefined
          ? 0
          : Number(this.editForm.DeductionRate); //扣重2 扣重(%)

      this.editForm.NetWeight = Number(
        grossWeight - tareWeight - buckleWeight
      ).toFixed(2);
      var deductWeight2 = (
        (this.editForm.NetWeight * deductionRate) /
        100
      ).toFixed(0);
      this.editForm.NetWeight = this.editForm.NetWeight - deductWeight2;
      if (this.editForm.CubRate > 0) {
        this.editForm.DiscountQuantity = (
          Number(this.editForm.NetWeight) / cubRate
        ).toFixed(2);
      }
      //对方毛重
      var otherGrossWeight =
        this.editForm.OtherGrossWeight == "" ||
        this.editForm.OtherGrossWeight == undefined
          ? 0
          : Number(this.editForm.OtherGrossWeight);
      //对方皮重
      var otherTareWeight =
        this.editForm.OtherTareWeight == "" ||
        this.editForm.OtherTareWeight == undefined
          ? 0
          : Number(this.editForm.OtherTareWeight);
      this.editForm.OtherNetWeight = otherGrossWeight - otherTareWeight;

      this.editForm.NetWeightDifference =
        this.editForm.OtherNetWeight - this.editForm.NetWeight;
    },
    formatDate(date) {
      function padZero(num) {
        return num < 10 ? "0" + num : num;
      }
      var year = date.getFullYear();
      var month = padZero(date.getMonth() + 1); // 月份是从0开始的
      var day = padZero(date.getDate());
      var hours = padZero(date.getHours());
      var minutes = padZero(date.getMinutes());
      var seconds = padZero(date.getSeconds());

      return (
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds
      );
    },
  },
  mounted() {
    let pastDate = new Date(new Date().setHours(0, 0, 0, 0));
    pastDate.setDate(pastDate.getDate()); //num正数为后一天，负数为前一天
    this.filters.startTime = this.formatDate(pastDate);

    let endDate = new Date(new Date().setHours(23, 59, 59, 0));
    endDate.setDate(endDate.getDate()); //num正数为后一天，负数为前一天
    this.filters.endTime = this.formatDate(endDate);
    this.getWeighingInHistry();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.GetWeighingInBaseData();
    this.getWhsettingDetail();
  },
};
</script>

<style lang="less" scoped>
/deep/.editForm {
  .el-select {
    width: 100%;
  }
}
</style>
